module.exports = __webpack_public_path__ + "static/media/sms.1b479f29.svg";